export const COVER_IMAGE_MIME_TYPES = [
  'image/bmp',
  'image/gif',
  'image/ico',
  'image/jfif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/tif',
  'image/tiff',
  'image/vnd.microsoft.icon',
  'image/webp',
  'video/3gpp',
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'video/webm',
  'video/x-ms-wmv',
  'video/x-msvideo',
] as const

export const coverImageAccept = (() => {
  const accept: Record<(typeof COVER_IMAGE_MIME_TYPES)[number], string[]> = Object.create(null)

  COVER_IMAGE_MIME_TYPES.forEach((mimeType) => {
    accept[mimeType] = []
  })

  return accept
})()
